import axios from 'axios';

// Use environment variable with fallback to production URL
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://xoom-rental-be.vercel.app/api/v1';
// For local development, create a .env file with: REACT_APP_API_URL=http://localhost:5001/api/v1
const API_BASE_URL =  'https://api.xoomdrives.com/api/v1';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error.response?.data || error.message);
  }
);

// API methods
export const customerAPI = {
  // Check or create customer account
  checkAccount: (data) => api.post('/customers/check-account', data),

  // Customer login
  login: (data) => api.post('/customers/login', data),

  // Get customer bookings
  getBookings: (params = {}) => api.get('/customers/bookings', { params }),

  // Get booking details
  getBookingDetail: (id) => api.get(`/customers/bookings/${id}`),

  // Get booking timeline
  getBookingTimeline: (id) => api.get(`/customers/bookings/${id}/timeline`),

  // edit booking time
  updateBooking: (id, data) => api.put(`/customers/bookings/${id}`, data),

  // Catalog endpoints (public - no auth required)
  getCatalog: (catalogId) => axios.get(`${API_BASE_URL}/catalogs/${catalogId}?source=customer`),

  getCatalogVehicle: (catalogId, vehicleId) => axios.get(`${API_BASE_URL}/catalogs/${catalogId}/vehicle/${vehicleId}`),


// Booking Agreement
getBookingAgreement: (bookingId) =>axios.get(`${API_BASE_URL}/bookings/preview/booking-agreement`, {params: { bookingId },}),
// Upload signed agreement
uploadSignedAgreement: (bookingId, file) => {
  const formData = new FormData();
  formData.append('bookingId', bookingId);
  formData.append('signedAgreement', file);

  return axios.patch(
    `${API_BASE_URL}/bookings/upload-signed-agreement`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
},




};

export default api;